// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__hRI9Q","footer":"ModalInfo_footer__2SxFD"};